const Header = ({ title }) => {
    return (
        <div className="mb-2">
            <h4 className="fz-18">{title}</h4>
            <hr style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', height: '1px' }} />
        </div>
    )
}

export default Header
